// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 583 ? "group-foo" : chunkId) + "." + {"496":"d2ae1d7a","583":"1c51ba01"}[chunkId] + ".css";
};